import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, NgZone, ChangeDetectorRef } from '@angular/core';
import { MapService } from '../map.service';
import { CommonService, DocumentsService } from '../../../services/common';
import { ThemeService } from '../../../services/common/theme.service';
import { JwtService } from '../../../auth/jwtservice';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DocumentSubType, DocumentTypes, KMLFor, SaleMapColors } from '../../../../appconfig';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-plain-mapview',
  templateUrl: './plain-mapview.component.html',
  styleUrls: ['./plain-mapview.component.scss']
})

export class PlainMapviewComponent implements OnInit, OnChanges {
  @Input() mapData: any //Map data related to map url etc.
  @Input() mapPolygonData: any // data of polygons (name, size etc. for sale units/khasras etc.)
  @Input() data: any
  @Output() closeMapDialogue = new EventEmitter<any>();
  @Output() NavigateMap = new EventEmitter<any>()
  @Output() layoutVersionChanged = new EventEmitter<any>();
  @Output() ParcelCountDetected = new EventEmitter<any>();
  selectedLayoutVersion: any = null;
  showLayoutVersionModal: boolean = false;

  onLayoutVersionChange(event: any) {
    this.layoutVersionChanged.emit(this.selectedLayoutVersion);
  }

  //we need to use ViewChild to get the map element reference after the view is initialized
  @ViewChild('map', { static: false }) mapElementRef!: ElementRef;

  info = new google.maps.InfoWindow()
  map: any;
  kmlUrl2: any;
  georssLayer: any
  currentZonalLayerType: any;
  zonalLayer: any[] = []
  zonalMarker: any[] = []
  normalMarker: any[] = []
  kmzOverlays: any[] = [] // Store KMZ overlays for toggling
  hideMarkers: boolean = false;
  xmlDoc: any;
  currPolygondata: any;
  showOwnerModal: boolean = false;
  showMediaModal: boolean = false;
  showPicModal: boolean = false;
  showDocumentModal: boolean = false;
  showKYCPanel: boolean = false;
  isDCUP: boolean = false

  // #region Show KML Layers (master plan or roads) */
  showDistrictMasterPlan: boolean = false;
  showVillageMasterPlan: boolean = false;
  showDicMasterPlan: boolean = false
  showRoads: boolean = false;
  showCOD: boolean = false;
  showLabels: boolean = false;

  showBarren: boolean = false;
  showStitched: boolean = false;
  showLayout: boolean = false;
  showVisualise: boolean = false;
  //#endregion




  showOwnerDetailsModal: boolean = false;
  showkhasraDetailsModal: boolean = false;
  showClientDetailsModal: boolean = false;
  showKmlUploadModal: boolean = false;

  showInfoWindow: boolean = false

  currentKhasraData: any;
  currentClickedKhasraOnFarmerModalData: any;
  currentUnitSaleRecord: any;
  userDocumentsData: any;

  currentLocationData: any;
  currentOwnerData: any

  showCalendarModal: boolean = false;

  currentKhasraTimeline: any[] = [];
  currentTimelineDate: any;
  enabledDates: Date[] = []; // Dates to be highlighted in the calendar
  maxDate = new Date();
  minDate = new Date();

  currentKhasraPics: any[] = [];
  currentSelectedPic: any;

  currentKhasraVideos: SafeResourceUrl[] = [];
  currentSelectedVideo: SafeResourceUrl | null = null;

  DMPLabelName: string = 'District Master Plan'
  // VMPLabelName: string = 'Village Master Plan'

  // isZonal: boolean = false;

  clientdata: any;


  // CSS on map to hide all labels/borders and points of interest
  customMapStyles: any = [
    {
      featureType: "all",
      elementType: "labels",
      stylers: [{ visibility: "off" }]
    },
    // {
    //   featureType: "all",
    //   elementType: "borders",
    //   stylers: [{ visibility: "off" }]
    // },
    {
      featureType: "poi",
      elementType: "all",
      stylers: [{ visibility: "off" }]
    },
    {
      featureType: "transit",
      elementType: "all",
      stylers: [{ visibility: "off" }]
    }
  ];

  canUploadKml: boolean = false;

  constructor(private router: Router, private mapService: MapService, private commonService: CommonService, private themeService: ThemeService,
    private ngZone: NgZone, private cdr: ChangeDetectorRef, private sanitizer: DomSanitizer, private documentService: DocumentsService, private jwtService: JwtService) {
    // Check if user has permission to upload KML files
    this.canUploadKml = this.jwtService.isCurrentUserInRole('Upload_Kml');
  }



  ngOnInit(): void {
    if (window.location.origin.toLowerCase().indexOf('local') > -1 || window.location.origin.toLowerCase().indexOf('dcup') > -1 || window.location.origin.toLowerCase().indexOf('bharatbhuvikas') > -1) {
      this.isDCUP = true;
    }
    // Set default selected layout version if available
    if (this.mapData?.layoutVersions?.length) {
      this.selectedLayoutVersion = this.mapData.selectedVersion || this.mapData.layoutVersions[0];
    }
  }


  ngOnChanges(changes: SimpleChanges): void {
    //reset all zonal and lable toggels
    this.normalMarker = []
    this.kmzOverlays = [] // Reset KMZ overlays
    this.showDistrictMasterPlan = false
    this.showVillageMasterPlan = false
    this.showDicMasterPlan = false
    this.showRoads = false
    this.showCOD = false
    this.showLabels = false

    this.showStitched = false
    this.showLayout = false
    this.showVisualise = false
    this.toggleNormalMarker({ "checked": false })

    // Use selectedVersion from mapData when mapData changes
    if (changes['mapData'] && this.mapData?.layoutVersions?.length) {
      this.selectedLayoutVersion = this.mapData.selectedVersion || this.mapData.layoutVersions[0];
    }

    //if maplevel is khasra then we need to get khasra map urls from khasra data
    if (this.mapData?.mapLevel?.toLowerCase() == 'khasra' && this.mapPolygonData) {
      this.mapData.mapUrl = this.getKhasraMapUrls(this.mapPolygonData)
    }
    else {
      this.initiateMap()
    }

    // Enable default layer for inventory views based on kmlLevel
    if (this.mapData?.kmlFor?.toLowerCase() == KMLFor.Inventory.toLowerCase()) {
      if (this.mapData?.kmlLevel?.toLowerCase() == 'operations') {
        this.showLayout = true;
        this.toggleZone('Layout', { "checked": this.showLayout });
      } else {
        this.showBarren = true;
        this.toggleZone('Barren', { "checked": this.showBarren });
      }
    }
  }

  //this method is used to get kml file from local file upload (for testing purpose only)
  onFileSelected(event: any) {
    const file = event.target.files[0];

    if (file) {
      //if getting KML File from local file upload (for testing purpose only)
      const kmlstring = this.mapService.getKmlFileFromLocalFile(file)
      this.initiateMap(kmlstring)
    }
  }

  /** Initializes and displays the map */
  initiateMap(localKmlString?: any) {
    if (this.mapData?.latingLitrals || this.mapData?.locationInfo || (this.mapData?.mapUrl?.length > 0)) {
      const centerPoint: google.maps.LatLngLiteral = {
        //default cordinates of centreal India
        lat: 22.3511148,
        lng: 78.6677428
      };

      //Set map properties like central location of map, zoom level and map type
      const mapProperties = {
        center: centerPoint,
        //If current level of map is country or state level then it should have zoom level at country level
        zoom: this.mapData?.mapLevel?.toLowerCase() == 'country' || this.mapData?.mapLevel?.toLowerCase() == 'state' ? 3 : 15,
        styles: this.customMapStyles,
        mapTypeId: google.maps.MapTypeId.HYBRID
      };

      this.map = null;
      this.zonalLayer = [];
      this.zonalMarker = [];
      // Use ViewChild reference instead of getElementById to support multiple component instances
      const mapElement = this.mapElementRef?.nativeElement || document.getElementById("map");
      this.map = new google.maps.Map(mapElement as HTMLElement, mapProperties);

      this.map.setTilt(0)

      if (this.mapData?.mapUrl?.length > 0) {

        //Khasra map layers from farmers in acqusition.
        this.mapData?.mapUrl.forEach((url: any) => {
          //if url is for kml file
          if (url.toLowerCase().indexOf('.kml') > 0) {
            //Map all layers which came into map data. There are chances when we need to overlap multiple layers of Phases (Plots) for sale and,
            this.georssLayer = new google.maps.KmlLayer({
              url: url,
              clickable: false, // Ensure KML layer doesn't steal clicks from our custom polygons
              zIndex: 1, // Explicitly force the base map tiles to the absolute bottom so custom vector polygons stay on top
              preserveViewport: false,
              suppressInfoWindows: true
            });

            //Check if current KML is for ZoneMap then it has to be at index 0 else at index 1 so that
            //khasra KML can be on top and its polygone are clickable
            var isZoneMapKML = this.checkIfZonalLayer(url.toLocaleLowerCase());

            google.maps.event.addListenerOnce(this.georssLayer, 'defaultviewport_changed', () => {
              this.mapService.getKmlFileStringFromUrl(url).subscribe(
                (kmlString: string) => {

                  //Sometimes in KML String there are ID or Name attributes in Document tag due to which it does not get parsed.
                  //Hence we need to repair/modify the KML string to make document tab normal without any attribute
                  kmlString = this.mapService.repairKMLString(kmlString)
                  //We are getting KML string from URL as KML File is not giving proper KMLS String to convert into xml doc
                  //Convert KML Layer string to XML DOC
                  const xmlDoc = this.mapService.parseKml(kmlString, url);

                  //Fetch all placemarks in kml layer
                  const placemarks = xmlDoc?.querySelectorAll('Placemark');

                  //check if it is a stitching layer by checking if the url contains stitching keyword
                  //and emit the placemark count for stitching layer to parent layer to show the parcel count
                  var isStitching = url.toLowerCase().indexOf('stitching') > -1
                  if (isStitching) {
                    this.ParcelCountDetected.emit(placemarks?.length || 0);
                  }

                  //Itrate through each Placemark to get name of placemark so that it can be matched with Unit name here
                  placemarks?.forEach((placemark: any) => {
                    const name = placemark.getElementsByTagName('name')[0]?.textContent;

                    //Not customizing any layer related to open space, road or central park (cp)
                    // if (!(name?.toLowerCase().includes('cp') || name?.toLowerCase().includes('road') || name?.toLowerCase().includes('open space'))) {

                    const polygon = this.mapService.getPlacemarkPolygon(placemark)
                    if (polygon) {

                      //fetch cordinate's path of current polygon
                      var path = this.mapService.getPolygoneCordinatesPath(polygon)
                      var area = google.maps.geometry.spherical.computeArea(path)
                      //Fetch current unit data for with same as of polygon name (as each polygon is names as unit name)
                      const currPolygondata = this.mapService.searchPolygon(this.mapPolygonData, name, this.mapData)

                      //Change color of polygone
                      const polygon1 = this.setSalePolygoneColor(currPolygondata, path, name, this.mapData?.kmlFor, isZoneMapKML, url)

                      //Add click event to polygon to display polygone information
                      google.maps.event.addListener(polygon1, 'click', (event: any) => {
                        if (this.mapService.isCurrentLevelforNavigation(this.mapData?.mapLevel))
                          this.NavigateToLayerClick(event, currPolygondata, name, this.mapData)
                        else
                          this.layerClick(event, currPolygondata, name, this.mapData?.kmlFor, currPolygondata?.mapId);
                      });

                      // Associate the polygon with its layer so it can be toggled and z-indexed correctly
                      let matchingZonalLayer: any = null;
                      if (isZoneMapKML) {
                        matchingZonalLayer = this.zonalLayer.find((z: any) => z.url === url);
                        if (matchingZonalLayer) {
                          if (!matchingZonalLayer.polygons) matchingZonalLayer.polygons = [];
                          matchingZonalLayer.polygons.push(polygon1);
                        }
                      }

                      //set the prepared polygon on the map only if eiter current kml is not a zonal kml or
                      //if it is a zonal kml and its parent KML layer is currently rendered on the map
                      if (!isZoneMapKML || (matchingZonalLayer && matchingZonalLayer.layer.getMap())) {
                        polygon1.setMap(this.map);
                      }
                      // }
                    }
                  });
                }, (error: any) => {
                  console.log('Error loading KML:', error);
                }
              );
            });

            if (this.checkIfZonalLayer(url.toLocaleLowerCase())) {
              this.zonalLayer.push({ "layerType": this.currentZonalLayerType, "layer": this.georssLayer, "url": url });
              if (this.mapData.isZonal) {
                this.zonalLayer.forEach(zLayer => {
                  if (zLayer.layerType == this.currentZonalLayerType)
                    zLayer.setMap(this.map);
                })
              }
            }
            else
              this.georssLayer.setMap(this.map);

            // this.georssLayer.setMap(!this.mapData.isZonal ? url.toLowerCase().indexOf('zonemap') >= 0 ? null : this.map : this.map)
          }
          else if (url.indexOf('.kmz') > 0) {
            var localUrl = url.replace(environment.apiEndpoint + '/api/', '').replace('download-file', 'download-kmz-file');
            //if URL is for a kmz file then it may contains and image then we need to show that image as overlay on map
            this.mapService.getKMZFileImageOverlay(localUrl).subscribe((res: any) => {
              if (res) {
                //convert location to proper lat long box
                const sw = new google.maps.LatLng(
                  Number(res.south),
                  Number(res.west)
                );

                const ne = new google.maps.LatLng(
                  Number(res.north),
                  Number(res.east)
                );

                const bounds = new google.maps.LatLngBounds(sw, ne);

                var imagrePath = 'KML%20Files%2F' + localUrl.substring(localUrl.indexOf('filePath=') + 9, localUrl.lastIndexOf('%2F'));

                this.documentService.getDocumentBytesByFolderPath(imagrePath).subscribe((imageRes: any) => {
                  if (imageRes?.result) {
                    var imageFileRecord = imageRes?.result.find((x: any) => x.fileName.toLowerCase() == res.imageName.toLowerCase());

                    let blob: any;
                    if (imageFileRecord?.base64Content != null && imageFileRecord?.base64Content != undefined) {
                      blob = this.commonService.base64ToBlob(
                        imageFileRecord?.base64Content,
                        'image/png' // or image/png
                      );

                      const imageUrl = URL.createObjectURL(blob);
                      const overlay = new google.maps.GroundOverlay(imageUrl, bounds);
                      overlay.setMap(null); // Initially hide KMZ overlay - show only when toggled on
                      // Store KMZ overlay for toggling visibility
                      this.kmzOverlays.push({ "layerType": 'Visualise', "overlay": overlay });
                      //force the map to show bound image.
                      this.map.fitBounds(bounds);
                    }
                  }
                });
              }
            });
          }
        });
      }
      else if (this.mapData?.locationInfo?.latitude !== undefined && this.mapData?.locationInfo?.longitude !== undefined) {
        this.displayLocationMarkerFromCoordinates();
      }
    }
  }


  /**
   * Gets the Khasra map urls for main khasra and all of it's adjacent khasras
   * @param khasradata
   */
  getKhasraMapUrls(khasradata: any) {
    //Check if khasra data is present
    if (khasradata) {
      //Get Khasra Map Urls from khasra data
      this.mapService.getKhasraKMLFileUrls(khasradata, (url) => {
        this.mapData.mapUrl = url
        this.initiateMap()
        // Filter out null or undefined urls
        // return khasraMapUrls?.filter((url: any) => url);
      });
    }
  }

  toggleZone(layerType: string, event: any) {
    //no need to toggle isZonal value as it is being done by switcing the input s
    // this.mapData.isZonal = !this.mapData.isZonal

    //Set current Layer Type to be toggled
    this.currentZonalLayerType = layerType;

    if (this.zonalLayer) {
      // Find the specific Layout URL to toggle ON if there are multiple
      let layoutUrlToToggle = '';
      if (layerType === 'Layout' && event.checked) {
        if (this.selectedLayoutVersion) {
          const selectedZLayer = this.zonalLayer.find((z: any) => z.layerType === 'Layout' && z.url.toLowerCase().replace(/ /g, '').indexOf(this.selectedLayoutVersion.toLowerCase().replace(/ /g, '')) > -1);
          if (selectedZLayer) layoutUrlToToggle = selectedZLayer.url;
        }
        // Fallback to first layout if no match found
        if (!layoutUrlToToggle) {
          const firstZLayer = this.zonalLayer.find((z: any) => z.layerType === 'Layout');
          if (firstZLayer) layoutUrlToToggle = firstZLayer.url;
        }
      }

      this.zonalLayer.forEach(zLayer => {
        if (zLayer?.layerType == layerType) {
          let shouldToggle = event.checked;
          // If turning Layout ON, only turn ON the specific chosen layout version; keep others OFF
          if (layerType === 'Layout' && event.checked) {
            shouldToggle = (zLayer.url === layoutUrlToToggle);
          }

          zLayer?.layer.setMap(shouldToggle ? this.map : null);
          if (zLayer.polygons) {
            zLayer.polygons.forEach((p: any) => p.setMap(shouldToggle ? this.map : null));
          }
        }
      })

      // Show labels only if both: layer is toggled ON and labels switch is ON
      this.zonalMarker.forEach(zMarker => {
        if (zMarker?.layerType == layerType)
          zMarker?.label.setMap((event.checked && this.showLabels) ? this.map : null)
      })
    }

    // Toggle KMZ overlays for Visualise layer
    if (layerType === 'Visualise') {
      this.kmzOverlays.forEach(overlay => {
        if (overlay?.overlay) {
          overlay.overlay.setMap(event.checked ? this.map : null);
        }
      });
    }
  }

  /**
   * Toggles the labels on map
   * @param event Event to decide show/hide lables
   */
  toggleNormalMarker(event: any) {
    // Toggle normal markers
    this.normalMarker.forEach(nMarker => {
      nMarker?.label.setMap(event.checked ? this.map : null)
    })

    // Toggle zonal markers - show only if label switch is ON and corresponding layer is ON
    this.zonalMarker.forEach(zMarker => {
      const layerType = zMarker?.layerType;
      let isLayerVisible = false;

      // Check if the layer corresponding to this marker is currently visible
      if (layerType === 'DMP') isLayerVisible = this.showDistrictMasterPlan;
      else if (layerType === 'VMP') isLayerVisible = this.showVillageMasterPlan;
      else if (layerType === 'DIC') isLayerVisible = this.showDicMasterPlan;
      else if (layerType === 'Roads') isLayerVisible = this.showRoads;
      else if (layerType === 'COD') isLayerVisible = this.showCOD;
      else if (layerType === 'Barren') isLayerVisible = this.showBarren;
      else if (layerType === 'Stitched') isLayerVisible = this.showStitched;
      else if (layerType === 'Layout') isLayerVisible = this.showLayout;

      // Show label only if label switch is ON and corresponding layer is ON
      zMarker?.label.setMap((event.checked && isLayerVisible) ? this.map : null)
    })
  }



  /**
   * Sets the color of polygons in the map based on their status
   * @param name Name of the polygon to be searched in polygon map data
   * @param path Path of cordinates to create the polygon location (to overrite)
   * @param kmlfor Purpose of KML to decide if different colour config for sales/purchase etc.
   * @returns Returns
   */
  setSalePolygoneColor(currPolygondata: any, path: any, polygonName: string, kmlfor: string, isZoneMapKML: boolean, kmlUrl: string) {
    //get color of polygon to be filled based on unit status and existance
    let polygoneFilColor = this.mapService.GetPolygonColorforMap(currPolygondata, this.mapData, this.mapPolygonData, polygonName, kmlUrl)

    let isNotFound = (polygoneFilColor == null || polygoneFilColor === '' || polygoneFilColor === '#808080');

    const localPolygon = new google.maps.Polygon({
      paths: path,
      strokeColor: (isNotFound && this.mapData?.kmlLevel?.toLowerCase() == 'operation') ? '#808080' : polygoneFilColor,
      strokeOpacity: isNotFound ? 0 : 1,   // only show border for colored polygons to avoid clutter
      strokeWeight: 2,
      fillColor: (isNotFound && this.mapData?.kmlLevel?.toLowerCase() == 'operation') ? '#808080' : polygoneFilColor,
      fillOpacity: polygoneFilColor == '' ? 0.0 : 0.4, //changes the opacity for fill colour of polygon
      zIndex: isNotFound ? 2 : 999999 // Ensure colored polygons ALWAYS stay above gray/unmatched ones
    })

    //if any khasra/gata is partially acquired i.e. if part of gata from at leasat 1 farmer is purchased or token paid in any khasra
    if (this.mapData?.kmlFor?.toLowerCase() == 'acquisition' || this.mapData?.kmlLevel?.toLowerCase() != 'operations') {
      var polygoneOutlineColor = '#00FF00'

      if (this.mapService.isInterestedLocation(currPolygondata)) {
        polygoneOutlineColor = '#FF0000';
      }

      if (this.mapData?.navigationMode?.toString().toLowerCase() == "map" || this.mapService.isInterestedLocation(currPolygondata)) {
        localPolygon.set('strokeColor', polygoneOutlineColor);
        localPolygon.set('strokeOpacity', 1);
        localPolygon.set('strokeWeight', 3);
      }
    }
    else if (this.mapData?.kmlFor?.toLowerCase() == 'sales' || this.mapData?.kmlFor?.toLowerCase() == 'inventory') {
      //in sales or inventory dashboard if current status of a unit is blocked or mortgaged then 
      //it has to be outlined with white color if mortgaged and yellow if blocked
      if (currPolygondata?.status?.toLowerCase() == 'mortgage' || currPolygondata?.status?.toLowerCase() == 'blocked')
        localPolygon.set('strokeColor', SaleMapColors.Mortgage);
      localPolygon.set('strokeOpacity', 1);
      localPolygon.set('strokeWeight', 3);
    }

    document.body.classList.toggle('zonalLayer', isZoneMapKML);

    //if current layer is a zonal layer then it makes it to be at front of all other layers
    if (!isZoneMapKML)
      localPolygon.set('zIndex', 1);

    const center = this.mapService.getCentroid(path)
    const label = new google.maps.Marker({
      position: center, // Position of the label (centroid of the polygon)
      map: null,
      icon: {
        // Customizing the label icon (can be an empty image or custom icon)
        url: '<text x="10" y="30" font-family="Arial" font-size="18" fill="white"></text>',
        // anchor: new google.maps.Point(0, 0)
      },
      zIndex: 9999999, // Ensure label is above the polygon
      // // title: polygonName, // Tooltip on hover
      label: {
        text: polygonName ? polygonName.toString() : '', // Text that will appear as the label
        color: 'white',
        fontSize: this.mapData?.kmlFor?.toLowerCase() == 'acquisition' ? '16px' : '24px'
      }
    });

    //if this is zonal layer then all of its marker has to be added into an array so that when we toggle the zonal kml layer 
    // then these marker lable should also be added. as lable marker are directly bound to map not to layer or polygone

    //Modifed on 04-Oct-2025: Since now we have different toggle for different type of layer hence we are adding all zonal layer type
    // so that when any of the zonal layer is toggled on/off we can show/hide its  respective markers also
    if (isZoneMapKML)
      this.zonalMarker.push({ "layerType": this.currentZonalLayerType, "label": label })
    else
      this.normalMarker.push({ "layerType": 'Normal Marker', "label": label })

    return localPolygon
  }

  NavigateToLayerClick(event: google.maps.MapMouseEvent, polygondata: any, polygoneName: string, mapData: any) {
    if (polygondata?.length > 0) {
      this.NavigateMap.emit({
        mapLevel: mapData?.mapLevel,
        clickedLocation: polygoneName,
        clickedLocationData: polygondata
      });
    }
    else {
      alert('No data found for ' + polygoneName + ' ' + mapData?.mapLevel);
    }
  }


  /**
   * Generate Polygon description view on click of polygon
   * @param event
   * @param polygon
   * @param PolygonName
   */
  layerClick(event: google.maps.MapMouseEvent, polygondata: any, polygoneName: string, kmlFor: string, mapId?: string) {
    var content = null;

    //close any existing info window before opening a new one
    this.info.close();
    let salePurchaseRecord: any = null;

    if (kmlFor?.toLocaleLowerCase() == 'sales' || kmlFor?.toLocaleLowerCase() == 'inventory') {
      //Get existance and status of current unit
      var polygonStatus = polygondata ? polygondata?.isAllotted ? 'Allotted' : 'Not Allotted' : 'Not Found'

      this.mapService.getHTMLContentForMap(kmlFor, polygonStatus)?.subscribe((cont: any) => {
        if (cont) {

          //Fetch current Allotment Data from sale purchase data array
          salePurchaseRecord = this.data.find((x: any) => x.unitDescriptionId == polygondata?.id)

          content = cont
            // .replace("{{appLogoPath}}", environment.assetsImagePath)
            .replace("{{appLogo}}", this.themeService.getTheme().logoUrl)
            .replace("{{unitName}}", polygondata ? polygondata?.name : '')
            .replace('{{area}}', polygondata?.unitCategory?.superArea)
            .replace('{{unitOfMeasure}}', polygondata?.unitCategory?.unitMeasurement?.name)
            .replace('{{polygoneName}}', polygoneName)
            .replace('{{allotmentUrl}}', ('/sales/allotment/' + (salePurchaseRecord ? salePurchaseRecord?.id : '')))
            .replace('{{allotmentStatus}}', polygonStatus)
            .replace('{{clientName}}', (salePurchaseRecord ? this.commonService.getUserNameFromObject(salePurchaseRecord?.clientDetail) : ''))

          this.info.setContent(content)
          this.info.setPosition(event.latLng); // Or set a specific position
          this.info.setOptions({
            disableAutoPan: true, // Keep it in place after it's opened
          })
          // google.maps.InfoWindow
          this.info.open(this.map);
        }
      })
    } else if (kmlFor == "Acquisition") {
      var polygonStatus = 'Not Found';
      //if current view of map is khasra levl then we will show all adjacent khasra map also even their status is not available
      //while in village khasra map for master plan kml polygons there will not be any khassa status in that case nothing to show
      if (polygondata?.status || this.mapPolygonData?.mapLevel?.toLowerCase() == 'khasra') {
        //Set HTML Content
        this.mapService.getHTMLContentForMap(kmlFor, polygondata?.status)?.subscribe((cont: any) => {
          if (cont) {
            content = cont
              // .replace("{{appLogoPath}}", environment.assetsImagePath)
              .replace("{{appLogo}}", this.themeService.getTheme().logoUrl)
              .replaceAll("{{khasraId}}", polygondata?.id ? polygondata?.id : polygondata?.adjacentKhasraId)
              .replaceAll("{{polygoneName}}", polygondata?.name)
              .replace("{{khataName}}", polygondata?.landKhata?.name)
              .replace('{{area}}', polygondata?.area)
              .replace('{{unitOfMeasure}}', polygondata?.unitOfMeasure?.name)
              .replace('{{status}}', polygondata?.status)
              .replace('{{Fasli1359}}', '')
              .replace('{{village}}', polygondata?.village?.name)
              .replace('{{tehsil}}', polygondata?.village?.tehsil?.name)
              .replace('{{district}}', polygondata?.village?.tehsil?.district?.name)
              .replace('{{state}}', polygondata?.village?.tehsil?.district?.state?.name)
              .replace('{{FarmerCount}}', polygondata?.farmers?.length ? polygondata?.farmers?.length : '0')

            //hide sajra map icon from quadrant if map id not available.
            const sajraMapSpan = document.getElementById('sajramapSpan');
            if (polygondata?.mapId == null || polygondata?.mapId == undefined)
              content = content.replace(/<span id="sajramapSpan"[\s\S]*?<\/span>/, '');

            // here code can placed for content click handeling. for now it is moved to outside of if condition of sale/acquisition
            //#region Content Click Handel

            //#endregion

            this.info.setContent(content)
            this.info.setPosition(event.latLng); // Or set a specific position
            this.info.setOptions({
              disableAutoPan: true, // Keep it in place after it's opened
            })
            // google.maps.InfoWindow
            this.info.open(this.map);
          }
        })
      }
    }

    // Attach click handler after InfoWindow is opened
    google.maps.event.addListenerOnce(this.info, 'domready', () => {
      // Use NgZone to ensure Angular change detection runs
      const khasraLink = document.getElementById('khasra-link');
      if (khasraLink) {
        khasraLink.addEventListener('click', (e) => {
          e.preventDefault();
          this.ngZone.run(() => {
            this.handleKhasraHyperlinkClick((polygondata?.id ? polygondata?.id : polygondata?.adjacentKhasraId));
          });
        });
      }
      const ownersLink = document.getElementById('owners-link');
      if (ownersLink) {
        ownersLink.addEventListener('click', (e) => {
          e.preventDefault();
          this.ngZone.run(() => {
            this.handleOwnerHyperlinkClick((polygondata?.id ? polygondata?.id : polygondata?.adjacentKhasraId), kmlFor, salePurchaseRecord);
          });
        });
      }
      const mediaLink = document.getElementById('media-link');
      if (mediaLink) {
        mediaLink.addEventListener('click', (e) => {
          e.preventDefault();
          this.ngZone.run(() => {
            this.handleMediaHyperlinkClick(polygondata, kmlFor, salePurchaseRecord);
          });
        });
      }
      const documentLink = document.getElementById('documents-link');
      if (documentLink) {
        documentLink.addEventListener('click', (e) => {
          e.preventDefault();
          this.ngZone.run(() => {
            this.handleDocumentLinkClick(polygondata, kmlFor, salePurchaseRecord);
          });
        });
      }
      const sajraMapLink = document.getElementById('sajra-map-link');
      if (sajraMapLink) {
        sajraMapLink.addEventListener('click', (e) => {
          e.preventDefault();
          this.ngZone.run(() => {
            this.handleSajraMapLink(mapId);
          });
        });
      }
    });
  }

  /**
   * Handles the click event on the hyperlink in the info window
   * @param polyogonId Polygon id(khasraID/UnitId) which was clicked to see owner details
   * @param kmlFor describe of current kml is loaded for sales or acquisition
   * @param clientDetail Detail of client whose information has to be shown
   */
  handleOwnerHyperlinkClick(polyogonId: any, kmlFor: string, currentSaleRecord?: any) {
    if (kmlFor.toLowerCase() == 'sales' || kmlFor.toLowerCase() == 'inventory') {
      //for sale map on click of owner link client details will be opend
      this.currentOwnerData = currentSaleRecord?.clientDetail
      //here sending current unit sale record separately so that we can use client details module just to show client details
      //or detail of current unit sold or purchased or other booking.allotment so that this record can be excluded from all sale records
      this.currentUnitSaleRecord = currentSaleRecord
      this.showClientDetailsModal = true
    }
    else if (kmlFor.toLowerCase() == 'acquisition') {
      //for acquisition map on click of owner link farmer details will be opend
      this.currentKhasraData = null;
      if (Array.isArray(this.mapPolygonData)) {
        this.currentKhasraData = this.mapPolygonData.find((x: any) => x.id == polyogonId);
      } else if (this.mapPolygonData && this.mapPolygonData.id == polyogonId) {
        this.currentKhasraData = this.mapPolygonData;
      } else {
        this.currentKhasraData = null;
      }
      this.showOwnerModal = true;
      ``
    }
  }

  /**
   * handels the click event on the khasra hyperlink in the info window
   * This will open a modal with khasra details
   * @param khasraId khasra ID for which details need to be displayed
   */
  handleKhasraHyperlinkClick(khasraId: any) {
    this.currentClickedKhasraOnFarmerModalData = { id: khasraId };
    this.showkhasraDetailsModal = true;
  }

  /**
   * Handles the click event on the media hyperlink in the info window
   * @param khasra The khasra data for which media needs to be displayed
   */
  handleMediaHyperlinkClick(khasra: any, kmlFor?: string, salePurchaseRecord?: any) {

    // Reset the current khasra media lists(pics and Videos both)
    this.currPolygondata = khasra;
    this.currentKhasraPics = [];
    this.currentKhasraVideos = [];
    this.enabledDates = [];
    this.currentKhasraTimeline = [];
    //Gets dates for which media files are available
    var folderPath = this.mapService.getAcquistionfilesLocationPaths(khasra)
    folderPath = folderPath + `/khasra/${khasra.plotNo}/Media/`
    this.mapService.getKhasraMediaFileTimeline(folderPath).subscribe((list: any) => {
      if (list?.result && list?.result?.length > 0) {
        //Since there are sub folders we would add only those sub folders to our timeline list which are valid date folder
        list?.result.forEach((subDir: any) => {
          if (this.isValidDate(subDir?.fileName))
            this.currentKhasraTimeline.push(subDir?.fileName)
        });

        this.enabledDates = this.currentKhasraTimeline
          .map(dateStr => {
            const [day, month, year] = dateStr.split('-').map(Number);
            return new Date(year, month - 1, day); // Month is 0-indexed in JavaScript
          })
          .sort((a, b) => b.getTime() - a.getTime()); // Sort in descending order

        this.currentTimelineDate = this.enabledDates[0]; // Set the first date as the current date

        this.maxDate = this.currentTimelineDate;
        this.minDate = this.enabledDates[this.enabledDates.length - 1];
        this.cdr.detectChanges();
      }
      this.showCalendarModal = true

    });

    // this.getMediaFilesForDate(this.currentTimelineDate)
  }

  /**
   * Handles the click event on the document hyperlink in the info window
   * @param khasra The khasra data for which media needs to be displayed
   */
  handleDocumentLinkClick(currentUnit: any, kmlFor: string, salePurchaseRecord?: any) {
    this.userDocumentsData = null;
    this.currentOwnerData = null;
    this.currPolygondata = currentUnit;
    if (kmlFor?.toLowerCase() == 'sales' || kmlFor?.toLowerCase() == 'inventory') {
      this.documentService.getFilterDocument(salePurchaseRecord?.clientId, salePurchaseRecord?.allotmentId, null, salePurchaseRecord?.projectId).subscribe(userDocs => {
        var profilePicData: any = null;
        if (userDocs?.result?.length > 0) {
          //set list of all documents of users so that it can be used on KYC Panel too
          this.userDocumentsData = userDocs?.result
          //Check if user has pic data already uploaded or not.
          profilePicData = userDocs?.result?.find((x: any) => x.documentSubTypeId == DocumentSubType.Photo)
          //Sets the user data object
          this.currentOwnerData = {
            "userId": salePurchaseRecord?.clientId,
            "documentData": this.userDocumentsData,
            "allotmentId": salePurchaseRecord?.id,
            "bookingId": salePurchaseRecord?.bookingId, //either booking id or allotment id will be available for sold plot
            "projectId": salePurchaseRecord?.projectId, //documentData is sent for kyc-panel and and land-panel
            "showIsVerified": true
          }
        }
      });
      this.showKYCPanel = true;
    }
    else if (kmlFor?.toLowerCase() == 'acquisition') {
      //since we have to display documents related to khasra we need to set current khasra id only
      this.currPolygondata = {
        "landKhasraId": currentUnit?.id,
        "documentTypeId": [DocumentTypes.Property]
      };
      this.showDocumentModal = true;
    }
  }

  handleSajraMapLink(mapId: any) {
    //open url in new tab so that acquisition kml map view will remain intact 
    //and we do not need to select all states, district tehsil or village again and again 
    if (mapId != null && mapId != undefined) {
      const tree = this.router.createUrlTree(['dashboard/acquisition-sajra-map/' + mapId]);
      const url = this.router.serializeUrl(tree);
      window.open(url, '_blank');
    }
  }

  isValidDate(dateString: string): boolean {
    var date = new Date(dateString);
    //since our folder on azure are in "dd/mm/yy format and new Date() method expect "mm/dd/yy" format 
    //hence we need to check if date is > 12 then we need to check it by formating in mm/dd/yyy format "
    if (isNaN(date?.getTime())) {
      var [day, month, year] = dateString.split('-').map(Number);
      date = new Date(year, month - 1, day);
    }

    return !isNaN(date.getTime());
  }

  getMediaFilesForDate(date: any) {
    // Reset the current khasra media lists(pics and Videos both)
    //Get current khasra media pics from cloud
    this.showMediaModal = false;
    this.currentKhasraPics = [];
    this.currentKhasraVideos = [];
    var folderPath = this.mapService.getAcquistionfilesLocationPaths(this.currPolygondata)
    this.currentTimelineDate = `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()}`;
    folderPath = folderPath + `/khasra/${this.currPolygondata.plotNo}/Media/${this.currentTimelineDate}/Pics/`
    this.mapService.getKhasraMedia(folderPath, 'pics', true)
      .subscribe(
        (fileList: any) => {
          // Check if fileList and its result are defined
          if (fileList && fileList?.result) {
            this.currentKhasraPics = fileList?.result.map((img: any) => this.commonService.BaseStringToNormalString(img?.base64Content));
            this.cdr.detectChanges(); // Trigger change detection to update the view
          }
        });


    //Get current khasra media videos from cloud
    folderPath = folderPath.replace('Pics', 'Videos')
    this.mapService.getKhasraMedia(folderPath, 'videos', true)
      .subscribe(
        (fileList: any) => {
          // Check if fileList and its result are defined
          if (fileList) {
            this.currentKhasraVideos = fileList?.result?.map((video: any) => this.loadVideo(video?.base64Content));
            this.cdr.detectChanges(); // Trigger change detection to update the view
          }
        });

    this.showMediaModal = true;
  }


  /**
   * Highlights the current date of Calendar
   * @param date date to be highlighted
   * @returns returns if this should be highlighted or not based on availability in timeline data array
   */
  isHighlighted(date: any): boolean {
    return this.enabledDates.some(d =>
      d.getDate() === date.day &&
      d.getMonth() === (date.month) && // PrimeNG month is 1-based
      d.getFullYear() === date.year
    );
    // return this.isEnabled(date); // Use same condition for highlighting
  }


  /**
   * Display the selected picture in full screen
   * @param selectedPic Selected picture to be displayed in full screen
   */
  openImageInFullScreen(selectedPic: any) {
    // Create a new window or tab and display the image in full screen
    this.currentSelectedPic = selectedPic
    this.showPicModal = true;
  }


  /**
   * Loads a video from base64 data and returns a sanitized URL for safe use in the template
   * @param base64Data base64 encoded video data
   * @returns 
   */
  loadVideo(base64Data: string) {
    const videoBlob = this.commonService.base64ToBlob(base64Data, 'video/mp4');
    const videoObjectUrl = URL.createObjectURL(videoBlob);
    return this.sanitizer.bypassSecurityTrustResourceUrl(videoObjectUrl);
  }



  openFarmerModal(currentFarmer: any) {
    this.currentOwnerData = currentFarmer;
    this.showkhasraDetailsModal = false;
    this.showOwnerDetailsModal = true;
  }

  openKhasraModal(currentKhasra: any) {
    this.showOwnerDetailsModal = false;
    this.showkhasraDetailsModal = false;
    //it may be possible that current khasra is not having id but it has adjacentKhasraId (if user clicked on adjacent khasra)
    this.currentClickedKhasraOnFarmerModalData = { id: currentKhasra?.khasra?.id ? currentKhasra?.khasra?.id : currentKhasra?.khasra?.adjacentKhasraId };
    //need to hid and show the khasra modal again to refresh the data
    this.showkhasraDetailsModal = true;
  }

  /**Checks if current kml layer is any master plan layer intentended to show or not
   * as now there are multiple master plan layers like district master plan, village master plan and roads plan
   * which can be toggled on/off at same time
   * @param url Url of kml layer
   * @return returns true if this layer is intended to be shown otherwise false
   */
  checkIfZonalLayer(url: any): boolean {
    if (url.toLocaleLowerCase().indexOf('districtmasterplan') >= 0) {
      this.currentZonalLayerType = 'DMP';
      return true;
    }
    else if (url.toLocaleLowerCase().indexOf('villagemasterplan') >= 0) {
      this.currentZonalLayerType = 'VMP';
      return true;
    }
    else if (url.toLocaleLowerCase().indexOf('roadsplan') >= 0) {
      this.currentZonalLayerType = 'Roads';
      return true;
    }
    else if (url.toLocaleLowerCase().indexOf('centerofdevelopment') >= 0) {
      this.currentZonalLayerType = 'COD';
      return true;
    }
    else if (url.toLocaleLowerCase().indexOf('dicmasterplan') >= 0) {
      this.currentZonalLayerType = 'DIC';
      return true;
    }
    else if (url.toLocaleLowerCase().indexOf('barren') >= 0) {
      this.currentZonalLayerType = 'Barren';
      return true;
    }
    else if (url.toLocaleLowerCase().indexOf('stitching') >= 0) {
      this.currentZonalLayerType = 'Stitched';
      return true;
    }
    else if (url.toLocaleLowerCase().indexOf('plainlayout') >= 0) {
      this.currentZonalLayerType = 'Layout';
      return true;
    }
    else if (url.toLocaleLowerCase().indexOf('visualise') >= 0) {
      this.currentZonalLayerType = 'Visualise';
      return true;
    }
    else
      return false
  }

  openLayoutVersionModal() {
    this.showLayoutVersionModal = true;
  }

  closeLayoutVersionModal() {
    this.showLayoutVersionModal = false;
  }

  /**
   * Open KML upload dialog
   */
  openKmlUploadDialog() {
    this.showKmlUploadModal = true;
  }

  /**
   * Handle KML upload modal visibility change (close dialog)
   */
  onKmlUploadModalChange(visible: boolean) {
    this.showKmlUploadModal = visible;
    // Optionally refresh map data after successful upload
    // this.onMapDataRefresh();
  }

  /**
   * Handle KML version change event from successful KML submission
   * This triggers refresh of KML URLs in the parent component (project-details)
   */
  onKmlVersionChangeSubmitted(event: any) {
    // Emit the layout version change event to parent component (project-details)
    // This will trigger fetching of fresh KML URLs
    this.layoutVersionChanged.emit(event);
  }

  /**
   * Displays a marker at the location coordinates from mapData.locationInfo
   * Shows an info window with coordinates and location name
   */
  displayLocationMarkerFromCoordinates(): void {
    if (!this.map) {
      console.warn('Map not initialized yet, returning');
      return;
    }

    if (!this.mapData?.locationInfo) {
      console.warn('No locationInfo available');
      return;
    }

    const latitude = this.mapData.locationInfo.latitude;
    const longitude = this.mapData.locationInfo.longitude;
    const locationName = this.mapData.locationInfo.locationName || 'Location';

    // Create marker position
    const markerPosition: google.maps.LatLngLiteral = {
      lat: latitude,
      lng: longitude
    };

    // Center map on the location
    this.map.setCenter(markerPosition);
    this.map.setZoom(16);

    // Create marker
    const marker = new google.maps.Marker({
      position: markerPosition,
      map: this.map,
      title: locationName,
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 10,
        fillColor: '#2b00ff',
        fillOpacity: 0.8,
        strokeColor: '#fff',
        strokeWeight: 2,
      }
    });

    // Create info window with coordinates and location name
    const infoWindow = new google.maps.InfoWindow({
      content: `<div style="color: #000; padding: 8px; font-weight: bold;">
        <strong>Location</strong><br/>
        Lat: ${latitude.toFixed(6)} Lng: ${longitude.toFixed(6)}<br/>
        ${locationName}
      </div>`
    });

    // Show info window on marker click
    marker.addListener('click', () => {
      infoWindow.open(this.map, marker);
    });

    // Open info window on initial load
    infoWindow.open(this.map, marker);
  }
}